import ipRegex from 'ip-regex'

export default {
  getMessage: () => 'Invalid whitelist format.',
  validate: value =>
    typeof value === 'string' &&
    value
      .split(',')
      .map(v => v.trim())
      .filter(v => v !== '')
      .map(v => ipRegex({ exact: true }).test(v))
      .every(v => v === true)
}
